// extracted by mini-css-extract-plugin
export default {"item":"OneInvestigation_item__AMBkb","item_img":"OneInvestigation_item_img__2EP3N","item_title":"OneInvestigation_item_title__-kM6k"};